import type {
  DomainAssignee,
  GroupedDomainAssignee,
} from '../../../types/permissions.types'

// The assignees endpoint returns one entry per (assignee, role) tuple; collapse them into one
// entry per assignee, preserving first-seen order. Grouping only spans the entries passed in
// (i.e. the current page of a paginated response).
export const groupDomainAssignees = (
  assignees: DomainAssignee[]
): GroupedDomainAssignee[] => {
  const grouped = new Map<string, GroupedDomainAssignee>()

  assignees.forEach((assignee) => {
    const key = `${assignee.type}:${assignee.id}`
    const existing = grouped.get(key)

    if (existing) {
      if (!existing.roles.includes(assignee.role)) {
        existing.roles.push(assignee.role)
      }

      return
    }

    grouped.set(
      key,
      assignee.type === 'account'
        ? {
            type: 'account',
            id: assignee.id,
            email: assignee.email,
            fullName: assignee.fullName,
            roles: [assignee.role],
          }
        : {
            type: 'group',
            id: assignee.id,
            name: assignee.name,
            roles: [assignee.role],
          }
    )
  })

  return [...grouped.values()]
}
